const NodeTypes = {
  ELEMENT_NODE: 1,
  TEXT_NODE: 3,
}

function getClassNames(node) {
  let classNames = []
  if(node.nodeType === NodeTypes.ELEMENT_NODE) {
    const ele = (node)
    classNames = (ele.className && ele.className.split) ? ele.className.split(' ') : []
  }
  return classNames
}

export function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export function getTextNodes(node, ignoreClass = [], ignore = false) {
  const textNodes = []
  const e = node.childNodes

  for(let i = 0; i < e.length; i++) {
    const element = e[i]
    element.ignore = ignore
    const classNames = getClassNames(element)
    if(ignoreClass.length > 0 && classNames.length > 0) {
      if(ignoreClass.some(item => classNames.includes(item))) {
        element.ignore = true
      }
    }
    if(element.nodeType === NodeTypes.TEXT_NODE && element.parentElement?.nodeName !== 'SCRIPT' && element.textContent?.trim() !== '') {
      if(element.textContent && element.textContent !== '\n') {
        textNodes.push(element)
      }
    } 
    else if(element.nodeType === NodeTypes.ELEMENT_NODE) {
      textNodes.push(...getTextNodes(element, ignoreClass, element.ignore))
    }
  }
  return textNodes
}

export function sliceTextNodes(textNodes, startTextNode, endTextNode) {
  const startIndex = textNodes.indexOf(startTextNode)
  const endIndex = textNodes.indexOf(endTextNode)
  const rangeText = textNodes.filter((_, i) => {
    return startIndex <= i && endIndex >= i
  })
  return rangeText
}
